import { blue } from '../customColors'

export default function Menu (theme: any) {
  return {
    MuiMenuItem: {
      styleOverrides: {
        root: {
          '&.header-menu-item': {
            color: theme.palette.grey[70],
            '&:hover': {
              color: theme.palette.grey[50],
              // backgroundColor: theme.palette.grey[98]
              backgroundColor: 'transparent'
            },
            '&.active': {
              backgroundColor: blue[500],
              color: theme.palette.background.paper,
              '&:hover': {
                backgroundColor: theme.palette.secondary.dark
              }
            }
          }
        }
      }
    }
  }
}
